import { render, staticRenderFns } from "./BulbTOC.vue?vue&type=template&id=615cdff8"
import script from "./BulbTOC.vue?vue&type=script&lang=js"
export * from "./BulbTOC.vue?vue&type=script&lang=js"
import style0 from "./BulbTOC.vue?vue&type=style&index=0&id=615cdff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports